var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M5.86603 8C5.48113 8.66667 4.51887 8.66667 4.13397 8L0.669873 2C0.284972 1.33333 0.766098 0.500001 1.5359 0.500001L8.4641 0.5C9.2339 0.5 9.71503 1.33333 9.33013 2L5.86603 8Z",
    fill: "url(#paint0_linear_4_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_22",
    x1: 10.9072,
    y1: 3.28182,
    x2: -0.891753,
    y2: 3.28182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43FFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDetails);
export default __webpack_public_path__ + "static/media/more-details.a538f0378cd850a1fda912e6c990838b.svg";
export { ForwardRef as ReactComponent };